import React from 'react';
import { Icon } from '../Icon';
import type { IconProps } from '../.types/IconPropsType';

export function EmptyStarIcon(props: IconProps) {
  return (
    <Icon {...props}>
      <svg
        width="16px"
        height="16px"
        viewBox="0 0 12 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        pointerEvents="none"
      >
        <path
          pointerEvents="none"
          d="M6 0.768982L7.7 4.21298L11.5 4.76498L8.75 7.44498L9.399 11.231L6 9.44398L2.601 11.231L3.25 7.44498L0.5 4.76498L4.3 4.21298L6 0.768982Z"
          stroke="#F5D63D"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </Icon>
  );
}
